<script>
  import { onDestroy, onMount } from 'svelte';
  import { getStr, isDirectionRTL } from '../../../common/util';
  import Text from '../../common/components/Text.svelte';
  import { showTimer } from '../store/validation';
  import { remainingDays, remainingHours, remainingMinutes, remainingSeconds } from './Timer';

  export let dealEnd;
  export let bg = '';
  export let color = '';
  export let isPDPTimer = false;
  export let isComingSoon = false;
  export let preorder = false;

  const isRTL = isDirectionRTL();

  let countDownDate = null;
  let remainingTime = null;
  let timer;

  // Parse and normalize dealEnd once it's available
  $: {
    if (dealEnd) {
      if (typeof dealEnd === 'number') {
        countDownDate = dealEnd;
      } else if (dealEnd instanceof Date) {
        countDownDate = dealEnd.getTime();
      } else if (typeof dealEnd === 'string') {
        const parsed = new Date(dealEnd);
        if (!isNaN(parsed)) {
          countDownDate = parsed.getTime();
        } else {
          console.error('Invalid date string format for dealEnd:', dealEnd);
          countDownDate = null;
        }
      } else {
        console.error('Unexpected type for dealEnd:', typeof dealEnd);
        countDownDate = null;
      }
    }
  }

  // Start the countdown timer when countDownDate is ready
  onMount(() => {
    timer = setInterval(() => {
      if (countDownDate) {
        const timeLeft = countDownDate - Date.now();
        remainingTime = timeLeft > 0 ? timeLeft : 0;
        $showTimer = timeLeft > 0;
      }
    }, 1000);

    return () => clearInterval(timer);
  });

  onDestroy(() => {
    clearInterval(timer);
  });

  // Reactive time parts
  $: days = remainingDays(remainingTime);
  $: hours = remainingHours(remainingTime);
  $: minutes = remainingMinutes(remainingTime);
  $: seconds = remainingSeconds(remainingTime);

  function getTimerStyle(bg, color) {
    return `background-color : ${bg}; color: ${color}`;
  }

  const dayLabel = getStr('extra.warranty.Day');
  const daysLabel = getStr('text.countdown.days');
  const Dlabel = getStr('text.countdown.d');
  const Hlabel = getStr('text.countdown.h');
  const Mlabel = getStr('text.countdown.m');
  const Slabel = getStr('text.countdown.s');
</script>

{#if $showTimer}
  <div
    class="timer-container"
    class:rtl={isRTL}
    style={getTimerStyle(bg, color)}
    class:PDPTimerStyle={isPDPTimer}
    class:isComingSoonBg={isComingSoon}
    class:preorderTimerStyle={preorder}
  >
    {#if days > 0}
      <div class="days">
        <span>{days}</span>
        {#if isPDPTimer}
          <span>{Dlabel}</span>
        {:else}
          <span>{days > 1 ? daysLabel : dayLabel}</span>
        {/if}
      </div>
      <div class="spacer">:</div>
    {/if}
    <div class="hours">
      <span>{hours}</span>
      {#if isPDPTimer}
        <span>{Hlabel}</span>
      {:else}
        <span><Text key="text.countdown.hrs.text" /></span>
      {/if}
    </div>
    <div class="spacer">:</div>
    <div class="minutes">
      <span>{minutes}</span>
      {#if isPDPTimer}
        <span>{Mlabel}</span>
      {:else}
        <span><Text key="text.countdown.mins" /></span>
      {/if}
    </div>
    <div class="spacer">:</div>
    <div class="seconds">
      <span>{seconds}</span>
      {#if isPDPTimer}
        <span>{Slabel}</span>
      {:else}
        <span><Text key="text.countdown.sec" /></span>
      {/if}
    </div>
  </div>
{/if}

<style lang="scss">
  @import '../styles/colors.new.scss';

  .timer-container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 7px;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    border-radius: 12px 12px 0px 0px;

    &.rtl {
      flex-direction: row;
    }

    .spacer {
      font-weight: 500;
      font-size: 14px;
      line-height: 15px;
    }
  }

  .PDPTimerStyle {
    font-weight: 500;
    gap: 8px;
    border: none;
    padding: 8px 0px;
    background-color: $functional-yellow;
    color: $primary-black;

    @include desktop-min-width {
      font-weight: 700;
      font-size: 28px;
      line-height: 32px;
      gap: 16px;
      padding: 12px 0px;
    }

    .spacer {
      @include desktop-min-width {
        font-weight: 700;
        font-size: 28px;
        line-height: 32px;
      }
    }
    &.preorderTimerStyle {
      padding: 9px 0px;
      background: transparent;
      color: #fff;
      &.isComingSoonBg {
        color: #04061b;
      }
    }
  }

  // .isComingSoonBg {
  //   background: $functional-green-03;
  // }
</style>
